import { ThemeType } from '../ThemeType';
import { addColoursToTheme } from '../addColoursToTheme';

export const blueTheme: ThemeType = addColoursToTheme({
  maxColumns: 3,
  body: '#fff',
  danger: '#fcebea',
  textDanger: '#E03C31',
  alert: '#FCF5E8',
  textAlert: '#E29E1A',
  neutral: '#FAFAFA',
  textNeutral: '#939598',
  neutralDark: '#F2F2F2',
  textNeutralDark: '#262A30',
  success: '#E6F6EF',
  textSuccess: '#07A35D',
  primary: '#078282',
  secondary: '#339E66',
  textPrimary: '#000',
  textSecondary: '#fff',
  banner: '#F5F5F5',
  button: '#F5F5F5',
  borderFaint: '#0ababa',
  borderDark: '#DFDFE0',
  alertMinHeight: '40px',
  sidebarWidth: '275px',
  buttonSubmitWidth: '150px',
  sidebarCollapsedWidth: '50px',
  sidebarHighlightDark: '#E29E1A',
  sidebarItemHeight: '40px',
  sidebarActiveBorderWidth: '5px',
  headerHeight: '62px',
  collapseHeaderHeight: '48px',
  bodyPadding: '20px',
  tableRowHeight: '35px',
  containerWidth: '1243px',
  signupContainerWidth: '670px',
  dropdownWidth: '275px',
  commisionInputWidth: '86px',
  buttonHeight: '40px',
  smallButtonHeight: '32px',
  termsAndConditionsHeight: '405px',
  scrollWidth: '6px',
  toggleButtonSpacing: '9px',
  smModalWidth: '374px',
  lgModalWidth: '588px',
  maxHeightModal: '640px',
  loginFormWidth: '508px',
  loginFormArrow: '46px',
  addressSearchClose: '7px',
  headerUserMenuWidth: '190px',
  smallFooterWidth: '1005px',
  collapseHeaderShadowHeight: '6px',
  ignoredDropdownWidth: '174px',
  maxNotesSectionHeight: '452px',
  taskStatusWidth: '85px',
  taskStageWidth: '185px',
  multiSelectChipLabelMaxWidth: '154px',
  esisHistoryHeight: '285px',
  taskEvidenceStatusWidth: '110px',
  taskEvidenceStatusDropdownWidth: '250px',
  taskEvidenceDocNameWidth: '270px',
  taskEvidenceDatetimeWidth: '130px',
  taskEvidenceActionsWidth: '55px',
  userIconSmSize: '10px',
  disbursementSummaryHeight: '502px',
  submitContentMaxHeight: '290px',
  colours: {
    primary: {
      1: '',
      2: '',
      3: '',
      4: '',
      5: '',
      6: '',
      7: '',
      8: '',
      9: '',
      10: '',
    },
    secondary: {
      1: '',
      2: '',
      3: '',
      4: '',
      5: '',
      6: '',
      7: '',
      8: '',
      9: '',
      10: '',
    },
    tertiary: {
      1: '',
      2: '',
      3: '',
      4: '',
      5: '',
      6: '',
      7: '',
      8: '',
      9: '',
      10: '',
    },
    neutral: {
      1: '',
      2: '',
      3: '',
      4: '',
      5: '',
      6: '',
      7: '',
      8: '',
      9: '',
      10: '',
    },
    warning: {
      1: '',
    },
    danger: {
      1: '',
    },
    success: {
      1: '',
    },
    info: {
      1: '',
    },
    link: {
      1: '',
      2: '',
      3: '',
    },
    highlight: {
      1: '',
    },
  },
  boxShadow: {
    1: '0px 4px 4px rgba(0, 0, 0, 0.15)',
    2: '0px 1px 4px 0px rgba(0, 0, 0, 0.10)',
  },
  borderWidth: {
    1: '1px',
    2: '2px',
    3: '4px',
  },
  borderRadius: {
    1: '4px',
    2: '8px',
  },
  padding: {
    1: '4px',
    2: '8px',
    3: '12px',
    4: '16px',
    5: '20px',
    6: '24px',
    7: '28px',
    8: '32px',
    9: '36px',
    10: '76px',
    11: '100px',
    12: '124px',
  },
  fontSize: {
    1: '12px',
    2: '14px',
    3: '16px',
    4: '18px',
    5: '20px',
    6: '22px',
    7: '24px',
    8: '32px',
    9: '40px',
    10: '44px',
    11: '48px',
  },
  fontWeight: {
    normal: '400',
    bold: '600',
    bolder: '700',
  },
  fontFamily: {
    1: 'Open Sans',
  },
  letterSpacing: {
    1: '1px',
  },
});
